<wp-single-view [workPackage]="workPackage"
                *ngIf="workPackage"></wp-single-view>